// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useLayoutEffect, useRef,
    useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Additional_bandwidth, i_bw_popup_props} from './additional_bandwidth';
import {t_order, t_zone_group} from '../../../../hola/pub/ui/pro/cp/orders';
import {Plan_table_popup} from './plan_table_popup/plan_table_popup';
import Icon_battery_low from '../../img/icons/24/battery_low.svg';
import Icon_bandwidth from '../../img/icons/24/bandwidth_oculus.svg';
import Icon_battery_full from '../../img/icons/24/battery_full.svg';
import Icon_repeat from '../../img/icons/16/repeat.svg';
import Icon_warning from '../../img/icons/16/warning.svg';
import Icon_alert from '../../img/icons/14/alert.svg';
import Icon_renewal_on from '../../img/icons/24/renewal.svg';
import Icon_add from '../../img/icons/16/add.svg';
import cn from 'classnames';
import {get_group_usage_info, get_payment_renew_url, get_price_per_gb,
    get_usage_info, order_has_renew_error, use_disappear} from './utils';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {www_hola} from 'hola_opt';
import {perr} from 'hola_pub_util';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
import {use_etask} from '../../../../hola/pub/lib/use_etask';
import {get_group_price_per_gb, is_unlimited_proxy_type} from '../../../../oculus/pub/ui/dashboard/utils';
import {Text_input} from '../../../../shared/ui/input';
import {api} from '../../lib/api';
import {use_app_context} from '../../lib/app_context';
import {LintHTMLDialogElement, Popup} from '../popup/popup';
import {Pie_chart} from '../toolip/pie_chart';
import Icon_bw_renewal from '../../img/icons/bw_renewal.svg';
import {Button} from '../shared/button';

import styles from './bandwidth_info.module.less';
import popup_styles from './plan_table_popup/plan_table_popup.module.less';
import {Bandwidth_free_full_popup} from './plan_table';

type t_bandwidth_text_type = 'with_renewal' | 'without_renewal' |
    'manage_renewal' | 'full_popup' | 'custom_text';

const get_bandwidth_text = (price_text: string, type: t_bandwidth_text_type,
    custom_text?: string | JSX.Element
)=>
{
    const templates = {
        with_renewal: <>
          Enable bandwidth auto-renewal, or manually add bandwidth as needed.
          <br/>
            Your GB price stays the same ({price_text})
            Any unused bandwidth will roll over.
          </>,
        without_renewal: <>
          You can add more bandwidth to
          your plan with the same price per GB ({price_text}).
        </>,
        manage_renewal: <>
          Edit the amount of bandwidth that is automatically added to your
          plan.
          <br/>
          <br/>
            Don't worry, it's the same price per GB ({price_text}).
            Any unused bandwidth rolls over to your next subscription.
          </>,
        full_popup: <>
          The average fee is {price_text} per GB. These charges will
          appear on your next billing cycle.
          </>,
        custom_text: typeof custom_text == 'string' ?
          custom_text.replace(/\{\{price_text\}\}/g, price_text) :
          custom_text
    };
    return templates[type];
};

interface i_low_popup_props extends i_bw_popup_props {
    order: t_order;
    on_checkout?: (zone_id: string, amount: number, price: number,
        group_id?: string)=>void;
    on_success: ()=>void;
    type?: 'LOW' | 'ADD'
    on_close?: ()=>void;
    cls?: string;
    stop_propagation?: boolean;
    title?: string | JSX.Element;
    popup_text?: string | JSX.Element
    no_icon?: boolean;
}
export const Bandwidth_low_popup = (props: i_low_popup_props)=>{
    const {order, per_gb, on_checkout, on_success,
      cls, on_close = null, type = 'LOW', stop_propagation=false,
      title, no_icon = false, popup_text} = props;
    const is_toolip = www_hola.site == 'toolip';
    const min_amount = Math.ceil(0.5 / per_gb);
    const [amount, set_amount] = useState(is_toolip ? 0 : min_amount);
    const price = per_gb * amount;
    const on_change = (value: string)=>{
        if (/^\d*$/.test(value))
            set_amount(+value);
    };
    const on_blur = ()=>{
        if (amount < min_amount)
            set_amount(min_amount);
    };
    const checkout_redirect = ()=>{
        on_checkout(order._id, amount, price, order.group_id);
    };
    const price_text = `$${per_gb.toFixed(2)}/GB`;
    const dialog_title = title || 'Add more bandwidth to keep your access';
    const text_type = order.allowed_bw_renewal ? 'with_renewal' :
        'without_renewal';
    const text = get_bandwidth_text(price_text,
      is_toolip ? 'custom_text' : text_type,
      popup_text,
    );
    return <Plan_table_popup
      reason='bandwidth'
      cls={cn(cls, {
        [styles.fixed_popup]: type ==='ADD',
        [styles.toolip_bandwidth_low_popup]: is_toolip,
      })}
      icon={no_icon ? undefined : type === 'LOW' ? <Icon_battery_low/> :
        <Icon_bandwidth />}
      type={type === 'LOW' ? 'warning' : 'success'}
      on_close={on_close} stop_propagation={stop_propagation}
      title={dialog_title}
      text={text}
      cta={order_has_renew_error(order) ? <Update_payment_method {...props} />
        :<>
          <Additional_bandwidth
            amount={amount}
            min_amount={min_amount}
            on_blur={on_blur}
            on_change={on_change}
            on_error={checkout_redirect}
            on_success={on_success}
            per_gb={per_gb}
            order={order}
          />
          {!is_toolip && <a className={styles.update_cc_link}
            onClick={checkout_redirect}>Use different card</a>}
        </>}
    />;
};


interface i_renew_manage_props extends i_bw_popup_props {
    order: t_order;
    on_close?: ()=>void;
    cls?: string;
}
export const Bandwidth_renew_manage_popup = (props: i_renew_manage_props)=>{
    const {order, per_gb, cls, on_close} = props;
    const {theme} = useContext(Settings_context);
    const min_gb = Math.ceil(0.5 / per_gb);
    const init_limit = order.extra_limit_renewal?.limit ?
        Math.round(order.extra_limit_renewal.limit/10**9) : min_gb;
    const is_enabled = order.extra_limit_renewal?.enable;
    const [limit_gb, set_gb] = useState(init_limit);
    const {show: show_success, visible: visible_success} = use_disappear(4);
    const {show: show_error, visible: visible_error} = use_disappear(4);
    const update_renew_params = ()=>api.update_extra_limit_renewal({
        zone_id: order._id, limit_gb, enable: true
    });
    const {exec, state} = use_etask<[],
        {success: boolean, error: string}>(update_renew_params);
    const input_disabled = state.loading;
    const btn_disabled = state.loading || !limit_gb || limit_gb < min_gb;
    const on_change = (value: string)=>{
        if (/^\d*$/.test(value))
            set_gb(+value);
    };
    const on_blur = ()=>{
        if (limit_gb < min_gb)
            set_gb(min_gb);
    };
    const price_text = `$${per_gb.toFixed(2)}/GB`;
    const btn_cls = cn(popup_styles.popup_btn,
        state.loading && popup_styles.loading);
    const on_submit = ()=>exec();
    useEffect(()=>{
        if (state.data?.error)
            show_error();
        if (state.data?.success)
            show_success();
    }, [state.data]);
    return <Plan_table_popup
      cls={cn(styles.fixed_popup, cls)}
      icon={<Icon_bw_renewal />}
      type={'empty'}
      on_close={on_close} stop_propagation={true}
      title={'Manage bandwidth renewal'}
      text={get_bandwidth_text(price_text, 'manage_renewal')}
      cta={<div className={popup_styles.additional_bw}>
        <p className={cn(theme.p14, theme.color_n700, popup_styles.label)}>
          Bandwidth (GB)
        </p>
        <div className={popup_styles.form}>
          <Text_input value={`${limit_gb}`} on_change={on_change}
            is_disabled={input_disabled} input_props={{onBlur: on_blur}}/>
          <Button size="s" cls={btn_cls}
            caption={is_enabled ? 'Update' : 'Enable'}
            on_click={on_submit} disabled={btn_disabled}
          />
        </div>
        {visible_success && !state.loading &&
        <div className={cn(theme.p12, theme.P,
          theme.bold, popup_styles.text_success)}>
          {is_enabled ? 'Updated!' : 'Enabled!'}
        </div>}
        {visible_error && !state.loading &&
        <div className={cn(theme.p12, theme.bold,
          theme.P, popup_styles.text_error)}>
          Failed to {is_enabled ? 'Update!' : 'Enable!'}
        </div>}
      </div>}
    />;
};

const Update_payment_method = ({order}: i_low_popup_props)=>{
    const {theme} = useContext(Settings_context);
    return <>
      <p className={cn(theme.p14, theme.color_n600, styles.mb24)}>
        Start by updating your payment method</p>
      <Button size='s' color='primary' caption='Update payment method'
        to={get_payment_renew_url(order)}
      />
    </>;
};

export const Bandwidth_full_popup = (props: i_bw_popup_props)=>{
    const {per_gb} = props;
    const price_text = `$${per_gb.toFixed(2)}`;
    return <Plan_table_popup
      type={'success'}
      icon={<Icon_battery_full/>}
      title={<>
        Additional usage charges have been enabled.
      </>}
      text={get_bandwidth_text(price_text, 'full_popup')}
    />;
};


interface i_bandwidth_info_props {
    order?: t_order;
    group?: t_zone_group;
    only_free_zone_visible?: boolean;
    ignore_warn_usage?: boolean;
    usage?: Partial<ReturnType<typeof get_usage_info>>;
    on_checkout?: (zone_id: string, amount: number, price: number,
        group_id?: string)=>void;
    hide_add_bandwidth?: boolean;
    is_extra_row?: boolean;
    show_low_limit_popup?: boolean;
}

export const Bandwidth_info = (props: i_bandwidth_info_props)=>{
    const {order, group, only_free_zone_visible, is_extra_row,
        ignore_warn_usage, hide_add_bandwidth, on_checkout} = props;
    const group_order = group?.zones?.[0];
    const {user, dashboard} = use_app_context();
    const {theme} = useContext(Settings_context);
    const is_toolip = www_hola.site == 'toolip';
    const history = useHistory();
    const [show_add_bw_popup, set_show_add_bw_popup] = useState(false);
    const per_gb = group
        ? get_group_price_per_gb(group)
        : get_price_per_gb(order);
    const group_extra_debug = use_debug_ui('group_extra');
    const show_group_extra = group && (group_extra_debug
        || www_hola.dashboard_group_extra_limits);
    const show_order_extra = order && order?.unit != 'ip';
    const show_extra_ui = !hide_add_bandwidth && !!per_gb
        && (!!show_group_extra && !!group?.allowed_bw_renewal)
        || show_order_extra && order?.allowed_bw_renewal;
    const tables = document.querySelectorAll('[class^="plans_content"]');
    const is_disabled_due_to_cb =
        order?.disabled?.reason == 'disabled_as_dispute_created';
    const handle_popup_open = (e: { stopPropagation: () => void; })=>{
        e.stopPropagation();
        if (is_toolip)
            return;
        if (!show_extra_ui || is_extra_row)
            return;
        if (show_add_bw_popup)
            return;
        set_show_add_bw_popup(true);
    };
    const handle_popup_close = ()=>{
        if (!show_add_bw_popup)
            return;
        set_show_add_bw_popup(false);
        tables.forEach(table=>(table as HTMLElement).style.zIndex = '');
    };
    useLayoutEffect(()=>{
        tables.forEach(table=>{
            table.addEventListener('click', e=>{
                const target = e.target as Element;
                const is_in_bw_info = target
                    .closest('[class^="bandwidth_info"]');
                const trigger_element = is_in_bw_info &&
                    (target instanceof SVGElement || target.closest('svg')) ?
                    target : target.closest('[class^="bandwidth_info"], ' +
                      '[class^="plus_btn"], [class^="usage_tooltip"]');
                if (trigger_element && e.target === trigger_element)
                    (table as HTMLElement).style.zIndex = '2';
            });
        });
    }, [tables]);
    useEffect(()=>{
        if (!order && !group || per_gb!=0)
            return;
        const zone_id = order?._id;
        const group_id = group?._id;
        const info = {zone_id, group_id};
        perr({id: 'oculus_extra_limits_zero_price', info});
    }, [order, group, per_gb]);
    const ref = useRef<LintHTMLDialogElement>(null);
    if (!order && !group)
        return null;
    if (is_unlimited_proxy_type(order?.type))
        return <span>unlimited</span>;
    const usage = props.usage ||
        (group ? get_group_usage_info(group) : get_usage_info(order));
    if (ignore_warn_usage)
        usage.is_warn_usage = false;
    const is_success = order?.enable_additional_usage_charges;
    const bw_renew_enabled = order?.extra_limit_renewal?.enable
        && order?.allowed_bw_renewal;
    if (is_success && show_extra_ui)
    {
        return <Popup show_on_hover
          on_toggle={ev=>ev.stopPropagation()}
          position="bottom"
          button_text={
            <span className={cn(styles.bandwidth_info, styles.success)}>
              <Pie_chart percentage={usage.percent_number}
                is_success_color/>
              {usage.percent}
              <Icon_repeat/>
            </span>}>
            <Bandwidth_full_popup per_gb={per_gb}/>
        </Popup>;
    }
    if (order?.free_zone && usage.is_full_usage)
    {
        return <Popup show_on_hover position="bottom"
          popup_cls={styles.bandwidth_info_popup}
          wrapper_cls={styles.bandwidth_wrapper}
          is_always_shown={only_free_zone_visible}
          button_text={
            <span className={cn(styles.bandwidth_info)}>
              <Pie_chart percentage={usage.percent_number}
                is_warn_color={usage.is_warn_usage}/>
              {usage.percent}
            </span>}>
            <Bandwidth_free_full_popup />
        </Popup>;
    }
    if (usage.is_warn_usage && show_extra_ui)
    {
        return <Popup show_on_hover
          popup_ref={ref}
          wrapper_cls={cn(
            {[styles.toolip_bandwidth_wrapper]: is_toolip}
          )}
          on_toggle={ev=>ev.stopPropagation()}
          position="bottom"
          button_text={
            <span className={cn(styles.bandwidth_info, styles.warning)}>
              <Pie_chart percentage={usage.percent_number} is_warn_color/>
              {usage.percent}
              {!is_toolip && <Icon_warning/>}
              {is_toolip && <Icon_alert/>}
            </span>}
        >
          <Bandwidth_low_popup per_gb={per_gb}
            order={group ? group_order : order}
            on_checkout={on_checkout}
            no_icon={true}
            title='It looks like you`re running low on Bandwidth'
            popup_text={is_toolip ? 'Don’t worry, you can add more '+
              'bandwidth to your'+
              ' plan with the same price per GB ({{price_text}}).': ''}
            {...(usage.percent_number < 100 ?
              {} : {title: 'You\'re out of Bandwidth'})}
            on_success={()=>{
              const email = user?.emails?.[0]?.value;
              history.push(`/dashboard/page/plans`
                +`?notification=extra_limit_success`
                +`&email=${encodeURIComponent(email)}`
              );
              dashboard.dispatch({type: 'refresh_orders'});
              ref.current?.close();
            }}
          />
        </Popup>;
    }
    return <div>
      <span className={cn(styles.bandwidth_info,
        is_disabled_due_to_cb && theme.color_n500)}
        data-tt={`${usage.used_label} out of ${usage.limit_label}`}
        onClick={handle_popup_open}>
        <Pie_chart percentage={usage.percent_number}
          is_warn_color={usage.is_warn_usage}
          is_full_color={usage.is_full_usage}
          is_disabled_color={is_disabled_due_to_cb}
        />
        {usage.percent}
        {show_extra_ui && !is_extra_row && !usage.is_full_usage &&
          !is_toolip && <button
          className={styles.plus_btn} onClick={handle_popup_open}>
          <Icon_add/>
        </button>}
      </span>
      {show_add_bw_popup && <Bandwidth_low_popup per_gb={per_gb} type='ADD'
        order={group ? group_order : order} on_checkout={on_checkout}
        cls={styles.add_bw_popup} stop_propagation={true}
        on_close={handle_popup_close}
        on_success={()=>{
          const email = user?.emails?.[0]?.value;
          history.push(`/dashboard/page/plans`
            +`?notification=extra_limit_success`
            +`&email=${encodeURIComponent(email)}`
          );
          dashboard.dispatch({type: 'refresh_orders'});
          set_show_add_bw_popup(false);
        }} />}
      {!is_extra_row && bw_renew_enabled &&
        <span className={styles.bandwidth_renew_enable}
          data-tt='Bandwidth renewal enabled'>
          <Icon_renewal_on/>
        </span>}
      {!is_extra_row && bw_renew_enabled &&
        order?.extra_limit_renewal?.errors?.length > 0 &&
        <p className={cn(theme.p10, theme.med, theme.color_err300,
          styles.bandwidth_renew_error)}>
          Bandwidth-renewal failed
        </p>}
    </div>;
};
